/**
 * Pre-process waitlist modal to inspect that sold out sizes on waitlist matches with sold out sizes on PDP.
 * This will finally modify waitlist content if either there were no sold-out sizes rendered there, missed sold out sizes or wrong ones.
 *
 * This is exclusive for internatinal user experiences
 * @param {HTMLDivElement} waitlistContent - wait list HTML content
 */
export const checkSoldOutItem = (waitlistContent) => {
  // 1. Get all rendered sold-out sizes on PDP
  const pdpSoldOutSizes = document.querySelectorAll(
    '.pdp-c-atc-size-selector__size-item--sold-out[data-availability="false"]',
  );
  // 2. Get all sold-out sizes in waitlist modal.
  const waitlistSizes = waitlistContent.querySelectorAll('.pdp-c-waitlist__size-item');
  // 3. Compare among them, they should match each other.
  // 3.1 if there were no sold-out sizes rendered in waitlist modal, we should populate them there with sold-out sizes rendered on PDP
  if (!waitlistSizes.length) {
    // Populate them
    const waitlistSizeList = waitlistContent.querySelector('.pdp-c-waitlist__size-list');
    pdpSoldOutSizes.forEach((missedSoldOutItem) => waitlistSizeList.appendChild(buildAnchor(missedSoldOutItem)));
  } else {
    // 3.2 Inspect whether there were wrong sold-out sizes on waitlist vs pdp sold-out sizes
    const wrongSoldOutSizes = checkLists(waitlistSizes, pdpSoldOutSizes);

    // 3.3 Inspect where the sold-out sizes on pdp match sold-out sizes rendered on waitlist. Otherwise, they will be marked as missed
    const missedSoldOutSizes = checkLists(pdpSoldOutSizes, waitlistSizes);

    // 4.1 Remove any wrong size rendered on waitlist modal
    wrongSoldOutSizes.forEach((wrongSoldOutSize) => wrongSoldOutSize.parentNode.remove());

    // 4.2 Were there missed items?
    if (missedSoldOutSizes.length) {
      // Add them to waitlist size list
      const waitlistSizeList = waitlistContent.querySelector('.pdp-c-waitlist__size-list');
      missedSoldOutSizes.forEach((missedSoldOutItem) => waitlistSizeList.appendChild(buildAnchor(missedSoldOutItem)));
    }
  }
};

/**
 * It will check existing elements in a NodeList vs b NodeList
 *
 * TO-DO: Presumably, there is Array method that is able to wrap all this block of code.
 * @param {NodeList} a - List of HTML nodes
 * @param {NodeList} b - List of HTML nodes
 * @returns {Array[Node]} - Array of HTML nodes
 */
const checkLists = (a, b) => {
  const result = [];

  a.forEach((aItem) => {
    const foundItem = Array.from(b).find((bItem) => aItem.dataset.variantId === bItem.dataset.variantI);
    if (!foundItem) result.push(aItem);
  });

  return result;
};

/**
 * This will create a sold out item HTML node
 * @param {HTMLAnchorElement} soldOutItem
 * @returns {HTMLLIElement} - anchor sold out element
 */
const buildAnchor = (soldOutItem) => {
  const anchor = document.createElement('li');
  anchor.innerHTML = `
    <a id="waitlist_size_selector_${soldOutItem.textContent.trim()}"
      class="pdp-c-waitlist__size-item ${
        soldOutItem.classList.contains('pdp-c-atc-size-selector__size-item--active')
          ? 'pdp-c-waitlist__size-item--selected'
          : ''
      }"
      data-variant-id="${soldOutItem.dataset.variantId}"
      data-variant-sku="${soldOutItem.dataset.sku}"
    >
      ${soldOutItem.textContent.trim()}
    </a>
  `;
  return anchor;
};
